import { render, staticRenderFns } from "./Shortform.vue?vue&type=template&id=15e80cc2&"
import script from "./Shortform.vue?vue&type=script&lang=js&"
export * from "./Shortform.vue?vue&type=script&lang=js&"
import style0 from "./Shortform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports